import {createAction, props} from '@ngrx/store';
import {EntityUpdate} from '~entity/entity-update/entity-update.model';

export const updatedsIds = createAction(
  '[EntityUpdate/API] UpdatedsIds',
  props<{ entities: EntityUpdate[] }>()
);

export const clearUpdatedsIds = createAction(
  '[EntityUpdate/API] Clear UpdatedsIds'
);
